import API from 'shared/lib/api'

API.prefix = window.booqableOptions.apiURL + '/api'

export default API
